import { Component } from '@angular/core';

/**
 * LoadingComponent displays a 3 dot (...) loader when the response is
 * being fetched by the chat streaming API and will be hidden once the 
 * streaming response begins.
 */
@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {}